<template>
  <Teleport to="body">
  <div class="modal fade" id="largeModal" tabindex="-1" :class="modalShow ? 'show' : ''" @click="closeModalCheckChild">
    <div class="modal-dialog modal-dialog-centered" :class="size" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel3">{{ modalTitle }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer" :class="footerPosition">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade" :class="modalShow ? 'show' : ''"></div>
  </Teleport>
</template>
<script>
import { VOnClickOutside as ClickOutside } from "@/helpers/directives/clickOutside"

export default {
  name: "BaseModal",
  data() {
    return {
      modalShow: false
    }
  },
  props: {
    modalTitle: {
      type: String
    },
    footerPosition: {
      type: String,
      default: 'center'
    },
    opened: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    }
  },
  emits: ['close'],
  methods: {
    closeModal() {
      if(this.modalShow){
        this.$emit('close')
        this.modalShow = false
      }
    },
    closeModalCheckChild(e) {
      if(e.target.id === 'largeModal'){
        this.closeModal()
      }
    },
    openModal(){
      setTimeout(() => this.modalShow = true, 100)
    }
  },
  directives: {
    ClickOutside
  },
  mounted() {
    if(this.opened){
      this.openModal()
    }
  }
}
</script>
<style scoped>
/* Выше бокового меню (.layout-menu, z-index 1090) */
.modal{
  z-index: 1100;
}
.modal.show{
  display: block;
}
.modal-backdrop{
  display: none;
  z-index: 1099;
}
.modal-backdrop.show{
  display: block;
}
</style>


<style scoped>
.modal-footer {
  display: flex;
  gap: 0.5rem;
}

.modal-footer.start {
  justify-content: flex-start;
}

.modal-footer.center {
  justify-content: center;
}

.modal-footer.end {
  justify-content: flex-end;
}

.modal-footer.between {
  justify-content: space-between;
}
</style>